const reward = [
    {name: 'school_goldenDust', type: 'currency', value: 750}
];

export default [
    {id: 1, instant: true, collection: 'weekendTrip', reward, color: 'pink', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 2.5, "icon": "mdi-ferris-wheel"},
        {"x": -1, "y": -0.05, "rotate": 0, "size": 1.7, "icon": "mdi-string-lights"},
        {"x": 1, "y": -0.05, "rotate": 0, "size": 1.7, "icon": "mdi-string-lights"},
        {"x": 0.85, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-candycane"},
        {"x": -0.95, "y": 0.95, "rotate": 35, "size": 0.75, "icon": "mdi-candy"},
        {"x": -0.65, "y": 0.85, "rotate": 80, "size": 0.75, "icon": "mdi-candy"},
        {"x": -0.9, "y": 0.7, "rotate": -5, "size": 0.75, "icon": "mdi-candy"}
    ]},
    {id: 2, instant: true, collection: 'weekendTrip', reward, color: 'light-blue', icons: [
        {"x": -0.6, "y": 0.8, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": -0.15, "y": 0.8, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": -0.6, "y": 0.45, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": -0.15, "y": 0.45, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": -0.15, "y": 0.1, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": -1, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-human-child"},
        {"x": 0.6, "y": 0.8, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": 0.6, "y": 0.45, "rotate": 0, "size": 1, "icon": "mdi-toy-brick"},
        {"x": 1, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-human-child"}
    ]},
    {id: 3, instant: true, collection: 'weekendTrip', reward, color: 'orange', icons: [
        {"x": -0.9, "y": 0.1, "rotate": 0, "size": 1.75, "icon": "mdi-grill"},
        {"x": 0.4, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-table-furniture"},
        {"x": 0, "y": -0.5, "rotate": 90, "size": 1, "icon": "mdi-food-steak"},
        {"x": 0.75, "y": -0.45, "rotate": 45, "size": 1, "icon": "mdi-baguette"}
    ]},
    {id: 4, instant: true, collection: 'weekendTrip', reward, color: 'pale-pink', icons: [
        {"x": -0.25, "y": 0.25, "rotate": 0, "size": 1.5, "icon": "mdi-human-male-female"},
        {"x": 0.8, "y": 0.5, "rotate": 0, "size": 1.5, "icon": "mdi-human-male-female"},
        {"x": -0.85, "y": 0.65, "rotate": 0, "size": 1.5, "icon": "mdi-human-male"},
        {"x": 0.25, "y": 0.85, "rotate": 0, "size": 1.5, "icon": "mdi-human-female"},
        {"x": -0.7, "y": -0.35, "rotate": 0, "size": 1, "icon": "mdi-party-popper"},
        {"x": 0.65, "y": -0.45, "rotate": 0, "size": 1.5, "icon": "mdi-cake-layered"},
        {"x": 0.35, "y": -0.5, "rotate": 0, "size": 1, "icon": "mdi-balloon"},
        {"x": 1, "y": -0.5, "rotate": 0, "size": 1, "icon": "mdi-balloon"}
    ]},
    {id: 5, instant: true, collection: 'weekendTrip', reward, color: 'light-green', icons: [
        {"x": 0.5, "y": -0.2, "rotate": 0, "size": 2.5, "icon": "mdi-home"},
        {"x": -1.15, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-fence"},
        {"x": -0.65, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-fence"},
        {"x": -0.15, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-fence"},
        {"x": 1.15, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-fence"},
        {"x": -0.75, "y": 0.65, "rotate": 0, "size": 1.2, "icon": "mdi-storefront"},
        {"x": 0.15, "y": 1, "rotate": 0, "size": 1, "icon": "mdi-human-male-female-child"}
    ]},
    {id: 6, instant: true, collection: 'weekendTrip', reward, color: 'darker-grey', icons: [
        {"x": 0.6, "y": -0.22, "rotate": 0, "size": 2, "icon": "mdi-store"},
        {"x": -0.4, "y": -0.15, "rotate": 0, "size": 1.4, "icon": "mdi-storage-tank"},
        {"x": -1, "y": 0, "rotate": 0, "size": 0.7, "icon": "mdi-grass"},
        {"x": -0.9, "y": 0.7, "rotate": 0, "size": 1.3, "icon": "mdi-gas-station"},
        {"x": 0.4, "y": 0.7, "rotate": 0, "size": 1.3, "icon": "mdi-gas-station"},
        {"x": 1, "y": 0.75, "rotate": 0, "size": 1, "icon": "mdi-car"}
    ]},
    {id: 7, instant: true, collection: 'weekendTrip', reward, color: 'yellow', icons: [
        {"x": 0, "y": 0.15, "rotate": 0, "size": 1.5, "icon": "mdi-scale"},
        {"x": -0.2, "y": -0.4, "rotate": 20, "size": 1, "icon": "mdi-carrot"},
        {"x": 0.15, "y": -0.4, "rotate": 0, "size": 1, "icon": "mdi-food-apple"},
        {"x": 0.9, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-human-greeting"},
        {"x": -0.9, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": 1.2, "y": 0.15, "rotate": 0, "size": 0.6, "icon": "mdi-wallet"}
    ]},
    {id: 8, instant: true, collection: 'weekendTrip', reward, color: 'brown', icons: [
        {"x": -0.75, "y": 0.25, "rotate": 0, "size": 1.5, "icon": "mdi-human-walker"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 1.5, "icon": "mdi-human-walker"},
        {"x": 0.8, "y": -0.27, "rotate": 0, "size": 1.1, "icon": "mdi-television-classic"},
        {"x": 0.8, "y": 0.25, "rotate": 0, "size": 1.25, "icon": "mdi-fireplace-off"},
        {"x": -0.5, "y": -0.6, "rotate": 0, "size": 0.5, "icon": "mdi-light-switch"}
    ]},
    {id: 9, instant: true, collection: 'weekendTrip', reward, color: 'purple', icons: [
        {"x": -0.9, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-slot-machine"},
        {"x": 0, "y": 0, "rotate": 0, "size": 1.5, "icon": "mdi-slot-machine"},
        {"x": 1, "y": 0.05, "rotate": 0, "size": 1.25, "icon": "mdi-human-greeting"},
        {"x": 0.65, "y": -0.3, "rotate": 0, "size": 0.5, "icon": "mdi-poker-chip"}
    ]},
    {id: 10, instant: true, collection: 'weekendTrip', reward, color: 'grey', icons: []},
    {id: 11, instant: true, collection: 'weekendTrip', reward, color: 'pale-light-green', icons: [
        {"x": 0, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-safe-square"},
        {"x": 0, "y": -0.5, "rotate": 0, "size": 3, "icon": "mdi-bank"},
        {"x": -1, "y": 1.08, "rotate": 0, "size": 0.8, "icon": "mdi-sack"},
        {"x": -0.65, "y": 1.05, "rotate": 0, "size": 1, "icon": "mdi-sack"}
    ]},
    {id: 12, instant: true, collection: 'weekendTrip', reward, color: 'pale-blue', icons: [
        {"x": -0.35, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-clipboard-outline"},
        {"x": -0.35, "y": 0.05, "rotate": 0, "size": 1, "icon": "mdi-finance"},
        {"x": -0.35, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-sign-pole"},
        {"x": 0.65, "y": 0.75, "rotate": 0, "size": 2, "icon": "mdi-human-greeting"}
    ]},
    {id: 13, instant: true, collection: 'weekendTrip', reward, color: 'green', icons: [
        {"x": 0, "y": -0.1, "rotate": 0, "size": 1.75, "icon": "mdi-cash-register"},
        {"x": -0.9, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": 0.9, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-human-greeting"},
        {"x": 0.45, "y": -0.55, "rotate": 25, "size": 0.75, "icon": "mdi-credit-card"}
    ]},

    {id: 14, instant: true, collection: 'tropicalParadise', reward, color: 'pale-yellow', icons: [
        {"x": -0.2, "y": 0.4, "rotate": 0, "size": 2, "icon": "mdi-cactus"},
        {"x": 1, "y": 0, "rotate": 0, "size": 1.75, "icon": "mdi-cactus"},
        {"x": -0.75, "y": -0.4, "rotate": 0, "size": 1.5, "icon": "mdi-cactus"},
        {"x": 0.5, "y": -0.8, "rotate": 0, "size": 1.25, "icon": "mdi-cactus"},
        {"x": 0.25, "y": -0.15, "rotate": 0, "size": 0.75, "icon": "mdi-snake"},
        {"x": -0.15, "y": -0.85, "rotate": 150, "size": 0.5, "icon": "mdi-spider"}
    ]},
    {id: 15, instant: true, collection: 'tropicalParadise', reward, color: 'blue', icons: [
        {"x": 0, "y": 0.02, "rotate": 0, "size": 2, "icon": "mdi-ferry"},
        {"x": -0.9, "y": 0.75, "rotate": 0, "size": 2, "icon": "mdi-waves"},
        {"x": 0, "y": 0.75, "rotate": 0, "size": 2, "icon": "mdi-waves"},
        {"x": 0.9, "y": 0.75, "rotate": 0, "size": 2, "icon": "mdi-waves"},
        {"x": 1, "y": -0.95, "rotate": 0, "size": 1, "icon": "mdi-paragliding"},
        {"x": 1, "y": -0.65, "rotate": 0, "size": 1, "icon": "mdi-human-handsup"},
        {"x": 0.8, "y": -0.75, "rotate": -65, "size": 1, "icon": "mdi-minus"},
        {"x": 0.65, "y": -0.45, "rotate": -65, "size": 1, "icon": "mdi-minus"},
        {"x": 0.5, "y": -0.15, "rotate": -65, "size": 1, "icon": "mdi-minus"}
    ]},
    {id: 16, instant: true, collection: 'tropicalParadise', reward, color: 'green', icons: [
        {"x": -0.1, "y": -0.4, "rotate": 0, "size": 2.25, "icon": "mdi-palm-tree"},
        {"x": 0.75, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-palm-tree"},
        {"x": -0.6, "y": 0.4, "rotate": 0, "size": 1.75, "icon": "mdi-palm-tree"},
        {"x": -0.9, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-grass"},
        {"x": -0.4, "y": -0.1, "rotate": 0, "size": 0.9, "icon": "mdi-grass"},
        {"x": 0.3, "y": 0.05, "rotate": 0, "size": 1.05, "icon": "mdi-grass"},
        {"x": -0.9, "y": 0.55, "rotate": 0, "size": 1.2, "icon": "mdi-grass"},
        {"x": 0.45, "y": 0.55, "rotate": 0, "size": 1.25, "icon": "mdi-grass"},
        {"x": -0.1, "y": 0.45, "rotate": 0, "size": 0.75, "icon": "mdi-flag-triangle"},
        {"x": 0.8, "y": -0.95, "rotate": 30, "size": 1.6, "icon": "mdi-weather-sunny"}
    ]},
    {id: 17, instant: true, collection: 'tropicalParadise', reward, color: 'lime', icons: [
        {"x": -0.65, "y": -0.4, "rotate": 0, "size": 2.25, "icon": "mdi-tower-beach"},
        {"x": 0.15, "y": -0.6, "rotate": 20, "size": 1.2, "icon": "mdi-umbrella-beach"},
        {"x": 0.9, "y": -0.6, "rotate": 70, "size": 1.2, "icon": "mdi-umbrella-beach"},
        {"x": 0.7, "y": 0.15, "rotate": 0, "size": 1.2, "icon": "mdi-turtle"},
        {"x": -0.9, "y": 0.8, "rotate": 0, "size": 2, "icon": "mdi-waves"},
        {"x": 0, "y": 0.8, "rotate": 0, "size": 2, "icon": "mdi-waves"},
        {"x": 0.9, "y": 0.8, "rotate": 0, "size": 2, "icon": "mdi-waves"}
    ]},
    {id: 18, instant: true, collection: 'tropicalParadise', reward, color: 'brown', icons: [
        {"x": -0.85, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-pot"},
        {"x": 0, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-pot"},
        {"x": 0.85, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-pot"},
        {"x": -0.85, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-flower"},
        {"x": 0, "y": 0.15, "rotate": 0, "size": 0.5, "icon": "mdi-sprout"},
        {"x": 0.85, "y": 0, "rotate": 0, "size": 1, "icon": "mdi-flower-tulip"},
        {"x": -0.3, "y": 1, "rotate": 0, "size": 0.8, "icon": "mdi-watering-can"}
    ]},
    {id: 19, instant: true, collection: 'tropicalParadise', reward, color: 'light-green', icons: [
        {"x": -0.4, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-microscope"},
        {"x": 0, "y": 0.12, "rotate": 35, "size": 0.4, "icon": "mdi-leaf"},
        {"x": 0.8, "y": 0.45, "rotate": 0, "size": 1.3, "icon": "mdi-pot"},
        {"x": 0.8, "y": 0.25, "rotate": 0, "size": 1, "icon": "mdi-nature"}
    ]},
    {id: 20, instant: true, collection: 'tropicalParadise', reward, color: 'dark-blue', icons: [
        {"x": -0.45, "y": 0.1, "rotate": 0, "size": 3, "icon": "mdi-ellipse-outline"},
        {"x": 0.7, "y": -0.1, "rotate": 0, "size": 2, "icon": "mdi-human-handsup"},
        {"x": 0.3, "y": -0.65, "rotate": -60, "size": 1.25, "icon": "mdi-spear"},
        {"x": 1, "y": -0.7, "rotate": 0, "size": 0.5, "icon": "mdi-fish"},
        {"x": -0.75, "y": 0, "rotate": 0, "size": 0.65, "icon": "mdi-fish"},
        {"x": -0.2, "y": 0.1, "rotate": 0, "size": 0.6, "icon": "mdi-fish"},
        {"x": -0.55, "y": 0.3, "rotate": 0, "size": 0.75, "icon": "mdi-fish"}
    ]},
    {id: 21, instant: true, collection: 'tropicalParadise', reward, color: 'pale-red', icons: [
        {"x": 0.85, "y": -0.6, "rotate": 0, "size": 1.75, "icon": "mdi-flag-checkered"},
        {"x": -0.9, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0.9, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": -0.9, "y": 0.9, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0, "y": 0.9, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": 0.9, "y": 0.9, "rotate": 0, "size": 3, "icon": "mdi-minus"},
        {"x": -0.55, "y": 0.3, "rotate": 0, "size": 0.7, "icon": "mdi-snail"},
        {"x": 0.25, "y": 0.45, "rotate": 0, "size": 0.75, "icon": "mdi-snail"},
        {"x": -0.3, "y": 0.6, "rotate": 0, "size": 0.8, "icon": "mdi-snail"},
        {"x": 0.7, "y": 0.47, "rotate": 90, "size": 1.75, "icon": "mdi-minus"}
    ]},
    {id: 22, instant: true, collection: 'tropicalParadise', reward, color: 'beige', icons: [
        {"x": 0, "y": -0.4, "rotate": 0, "size": 3, "icon": "mdi-island"},
        {"x": -0.65, "y": -0.45, "rotate": 20, "size": 1.5, "icon": "mdi-umbrella-beach"},
        {"x": -0.85, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-waves"},
        {"x": 0, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-waves"},
        {"x": 0.85, "y": 0.8, "rotate": 0, "size": 1.75, "icon": "mdi-waves"}
    ]},
    {id: 23, instant: true, collection: 'tropicalParadise', reward, color: 'pink-purple', icons: [
        {"x": -0.9, "y": 0.2, "rotate": 0, "size": 1.25, "icon": "mdi-speaker"},
        {"x": 0.9, "y": 0.2, "rotate": 0, "size": 1.25, "icon": "mdi-speaker"},
        {"x": -0.95, "y": -0.35, "rotate": 0, "size": 0.75, "icon": "mdi-music-note"},
        {"x": -0.75, "y": -0.7, "rotate": 0, "size": 0.6, "icon": "mdi-music-note"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 1, "icon": "mdi-amplifier"},
        {"x": 0.9, "y": -0.35, "rotate": 0, "size": 0.85, "icon": "mdi-music-note"},
        {"x": 0.7, "y": -0.7, "rotate": 0, "size": 0.75, "icon": "mdi-music-clef-treble"},
        {"x": 0.4, "y": -0.9, "rotate": 0, "size": 0.65, "icon": "mdi-music-note"}
    ]},

    {id: 24, instant: true, collection: 'coldTimes', reward, color: 'orange-red', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-sofa"},
        {"x": -0.95, "y": 0.2, "rotate": 0, "size": 1, "icon": "mdi-dresser"},
        {"x": -0.95, "y": -0.35, "rotate": 0, "size": 1.5, "icon": "mdi-lava-lamp"},
        {"x": 0.95, "y": 0.1, "rotate": 0, "size": 1.25, "icon": "mdi-fireplace"},
        {"x": -0.25, "y": 1, "rotate": 0, "size": 2, "icon": "mdi-rug"}
    ]},
    {id: 25, instant: true, collection: 'coldTimes', reward, color: 'light-grey', icons: [
        {"x": 0, "y": 0.01, "rotate": 0, "size": 3, "icon": "mdi-image-filter-hdr"},
        {"x": 0.55, "y": 0, "rotate": 0, "size": 1.9, "icon": "mdi-landslide"},
        {"x": -0.65, "y": 0, "rotate": 0, "size": 1.9, "icon": "mdi-volcano"}
    ]},
    {id: 26, instant: true, collection: 'coldTimes', reward, color: 'pale-purple', icons: [
        {"x": -0.85, "y": 0, "rotate": 0, "size": 2, "icon": "mdi-city-variant"},
        {"x": 0.85, "y": 0.05, "rotate": 0, "size": 2, "icon": "mdi-city"},
        {"x": -0.3, "y": 0.05, "rotate": 0, "size": 0.65, "icon": "mdi-outdoor-lamp"},
        {"x": 0.15, "y": 0.3, "rotate": 0, "size": 0.7, "icon": "mdi-sign-pole"},
        {"x": 0.15, "y": 0.05, "rotate": 0, "size": 0.7, "icon": "mdi-post-lamp"}
    ]},
    {id: 27, instant: true, collection: 'coldTimes', reward, color: 'red', icons: [
        {"x": -0.9, "y": 0.3, "rotate": 0, "size": 1.3, "icon": "mdi-cup"},
        {"x": -0.1, "y": 0.3, "rotate": 0, "size": 1.3, "icon": "mdi-cup"},
        {"x": -0.9, "y": -0.05, "rotate": 0, "size": 1, "icon": "mdi-smoke"},
        {"x": -0.1, "y": -0.05, "rotate": 0, "size": 1, "icon": "mdi-smoke"},
        {"x": 0.75, "y": -0.1, "rotate": 0, "size": 3, "icon": "mdi-bottle-soda-classic-outline"},
        {"x": 0.75, "y": -0.15, "rotate": 0, "size": 0.6, "icon": "mdi-food-apple"}
    ]},
    {id: 28, instant: true, collection: 'coldTimes', reward, color: 'deep-purple', icons: [
        {"x": -0.2, "y": 0.4, "rotate": 0, "size": 3, "icon": "mdi-pot-steam"},
        {"x": 0.85, "y": 0.5, "rotate": 0, "size": 2.25, "icon": "mdi-human-greeting"},
        {"x": 0.3, "y": 0.15, "rotate": 175, "size": 1, "icon": "mdi-silverware-spoon"},
        {"x": -0.45, "y": 0.25, "rotate": 125, "size": 1, "icon": "mdi-food-drumstick"},
        {"x": 0.6, "y": -0.9, "rotate": 0, "size": 1.5, "icon": "mdi-weather-night"}
    ]},
    {id: 29, instant: true, collection: 'coldTimes', reward, color: 'green', icons: [
        {"x": 0, "y": -0.4, "rotate": 0, "size": 2, "icon": "mdi-forest"},
        {"x": -0.55, "y": -0.1, "rotate": 0, "size": 2, "icon": "mdi-forest"},
        {"x": 0.8, "y": 0.1, "rotate": 0, "size": 2, "icon": "mdi-pine-tree"},
        {"x": 0, "y": 0.3, "rotate": 0, "size": 1, "icon": "mdi-waterfall"},
        {"x": -0.1, "y": 0.65, "rotate": 0, "size": 1, "icon": "mdi-waves"},
        {"x": -0.3, "y": 1, "rotate": 0, "size": 1, "icon": "mdi-waves"},
        {"x": 0.35, "y": 0.7, "rotate": 0, "size": 0.5, "icon": "mdi-grass"},
        {"x": 0.2, "y": 1, "rotate": 0, "size": 0.65, "icon": "mdi-grass"},
        {"x": -0.75, "y": 0.85, "rotate": 0, "size": 0.6, "icon": "mdi-grass"}
    ]},
    {id: 30, instant: true, collection: 'coldTimes', reward, color: 'light-blue', icons: [
        {"x": 0.3, "y": 0.2, "rotate": 0, "size": 2, "icon": "mdi-snowman"},
        {"x": -0.85, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-human-handsup"},
        {"x": -0.6, "y": -0.15, "rotate": -50, "size": 0.75, "icon": "mdi-carrot"},
        {"x": 0, "y": -0.95, "rotate": 0, "size": 1.3, "icon": "mdi-weather-snowy"},
        {"x": 0.8, "y": -0.5, "rotate": 0, "size": 0.8, "icon": "mdi-snowflake"},
        {"x": -0.35, "y": 0.25, "rotate": 0, "size": 0.6, "icon": "mdi-snowflake"}
    ]},
    {id: 31, instant: true, collection: 'coldTimes', reward, color: 'dark-blue', icons: [
        {"x": -0.7, "y": 0.7, "rotate": 0, "size": 2, "icon": "mdi-snowmobile"},
        {"x": -0.85, "y": 0.45, "rotate": 0, "size": 1.75, "icon": "mdi-walk"},
        {"x": 0.55, "y": 0.2, "rotate": 0, "size": 1.5, "icon": "mdi-snowshoeing"},
        {"x": -0.1, "y": -0.45, "rotate": 0, "size": 1, "icon": "mdi-snowboard"}
    ]},
    {id: 32, instant: true, collection: 'coldTimes', reward, color: 'blue-grey', icons: [
        {"x": 0, "y": -0.9, "rotate": 0, "size": 2, "icon": "mdi-chandelier"},
        {"x": 0.8, "y": 0.2, "rotate": 0, "size": 1.5, "icon": "mdi-candelabra-fire"},
        {"x": -0.2, "y": 0.5, "rotate": 0, "size": 1, "icon": "mdi-candle"},
        {"x": -0.75, "y": 0.7, "rotate": 0, "size": 2, "icon": "mdi-human-handsdown"},
        {"x": 0.8, "y": 0.85, "rotate": 0, "size": 1.3, "icon": "mdi-dresser"}
    ]},
    {id: 33, instant: true, collection: 'coldTimes', reward, color: 'yellow', icons: [
        {"x": 0, "y": 0.2, "rotate": 0, "size": 1.4, "icon": "mdi-lightbulb"},
        {"x": -0.8, "y": 0.2, "rotate": 0, "size": 1.4, "icon": "mdi-lightbulb-cfl"},
        {"x": 0.8, "y": 0.2, "rotate": 0, "size": 1.4, "icon": "mdi-lightbulb-cfl-spiral"},
        {"x": -0.4, "y": -0.6, "rotate": 45, "size": 1.4, "icon": "mdi-lightbulb-fluorescent-tube"},
        {"x": 0.4, "y": -0.6, "rotate": 0, "size": 1.4, "icon": "mdi-lightbulb-spot"},
        {"x": -0.5, "y": 0.6, "rotate": 0, "size": 0.7, "icon": "mdi-tag-text"},
        {"x": 0.3, "y": 0.6, "rotate": 0, "size": 0.7, "icon": "mdi-tag-text"},
        {"x": 1.1, "y": 0.6, "rotate": 0, "size": 0.7, "icon": "mdi-tag-text"},
        {"x": -0.15, "y": -0.2, "rotate": 0, "size": 0.7, "icon": "mdi-tag-text"},
        {"x": 0.7, "y": -0.2, "rotate": 0, "size": 0.7, "icon": "mdi-tag-text"}
    ]},
];
